(function() {
    'use strict';

    angular
        .module('app.procesarPlanilla')
        .run(appRun);

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/procesarPlanilla',
                config: {
                    templateUrl: 'app/procesarPlanilla/procesarPlanilla.html',
                    controller: 'ProcesarPlanilla',
                    controllerAs: 'vm',
                    title: 'ProcesarPlanilla'
                }
            },
            {
                url: '/planillaProcesada/:id',
                config: {
                    templateUrl: 'app/procesarPlanilla/planillaProcesada.html',
                    controller: 'PlanillaProcesada',
                    controllerAs: 'vm',
                    title: 'PlanillaProcesada'
                }
            },
            {
                url: '/planillaProcesada-detalle/:calendarizacionId/:empleadoId',
                config: {
                    templateUrl: 'app/procesarPlanilla/planillaProcesadaDetalle.html',
                    controller: 'PlanillaProcesadaDetalle',
                    controllerAs: 'vm',
                    title: 'PlanillaProcesadaDetalle'
                }
            }               
        ];
    }
})();
